var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import PurSortingService from "../../api/PurSortingService";
import CommonService from '../../api/CommonService';
import HeaderItem from "../accountcheck/components/HeaderItem.vue";
import stockPanelByGoods from "./components/stockPanelByGoods.vue";
import stockPanelByShop from "./components/stockPanelByShop.vue";
import { Loading } from 'element-ui';
import TableHeaderToolTip from '../../common/components/TableHeaderToolTip';
var Detail = (function (_super) {
    __extends(Detail, _super);
    function Detail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = document.documentElement.clientHeight - 380;
        _this.formData = {
            order_code: "",
            business_info: [],
            sorting_schedule: "",
            organ_name: "",
            purchase_order_order: [],
            order_icomment: "",
            depot_name: "",
            item_num: "",
            goods_detail: [],
            shop_detail: []
        };
        _this.listDataByGoods = [];
        _this.listDataByShop = [];
        _this.rowId = '';
        _this.activeName = '0';
        _this.supplierGoodsTypeList = [];
        _this.goodsFormData = {
            goods_type_id: undefined,
            keyword: '',
        };
        return _this;
    }
    Detail.prototype.created = function () {
        this.service = PurSortingService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    Detail.prototype.mounted = function () {
        if (this.rowId) {
            this.getDetail();
        }
        this.getGoodsTypeList();
    };
    Detail.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    Detail.prototype.search = function () {
        this.getDetail();
    };
    Detail.prototype.getGoodsTypeList = function () {
        var _this = this;
        this.commonService.getSupplierGoodsTypeList().then(function (res) {
            if (res.data.success) {
                _this.supplierGoodsTypeList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Detail.prototype.dealData = function (list) {
        list = list || [];
        return list.map(function (item) {
            return item;
        });
    };
    Detail.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.rowId,
            goods_type_id: this.goodsFormData.goods_type_id,
            keyword: this.goodsFormData.keyword,
        };
        this.service.getDetail(params).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            data.goods_detail = _this.dealData(data.goods_detail);
            _this.formData = data;
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    Detail.prototype.showPurchaseStockByGoods = function (row) {
        this.listDataByGoods = JSON.parse(JSON.stringify(row.business_shop_info));
        this.$refs.stockPanelByGoods.showRelease();
        window._czc.push(["_trackEvent", '分拣单详情', '按货品查看', '订货合计']);
    };
    Detail.prototype.showPurchaseStockByShop = function (row) {
        this.listDataByShop = JSON.parse(JSON.stringify(row.purchase_info));
        this.$refs.stockPanelByShop.showRelease();
        window._czc.push(["_trackEvent", '分拣单详情', '按门店查看', '订货合计']);
    };
    Detail.prototype.tabClick = function (tab) {
        if (tab.name == "0") {
            window._czc.push(["_trackEvent", '分拣单详情', '按货品查看', '按货品查看']);
        }
        else {
            window._czc.push(["_trackEvent", '分拣单详情', '按门店查看', '按门店查看']);
        }
    };
    Detail = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem,
                TableHeaderToolTip: TableHeaderToolTip,
                stockPanelByGoods: stockPanelByGoods,
                stockPanelByShop: stockPanelByShop
            },
            methods: {
                renderHeader: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: "销售系数*订货合计",
                            placement: "bottom"
                        }
                    }, '待领货');
                }
            }
        })
    ], Detail);
    return Detail;
}(Vue));
export default Detail;
